export default __webpack_public_path__ + "static/vision-d27aafc1557ce2d7b2537dc3d6060268.jpg";